import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { runInAction } from "mobx";
import { useVideoStore } from "../../../../../../shared/hooks/useVideoStore";
import { extractVideoFrames } from "../../../../utils/extractVideoFrames";
import { StoryboardStrip } from "./components/StoryboardStrip";

export const VideoPlayer = observer(() => {
    const videoStore = useVideoStore();
    const videoRef = useRef<HTMLVideoElement>(null);
    const [framesLoaded, setFramesLoaded] = useState(false);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleLoadedMetadata = () => {
            runInAction(() => {
                videoStore.setDuration(video.duration);
            });

            if (!framesLoaded) {
                // extractVideoFrames(video, 12).then((frames) => {
                //     runInAction(() => {
                //         videoStore.setFrames(frames);
                //         setFramesLoaded(true);
                //     });
                // });
            }
        };

        const handleTimeUpdate = () => {
            runInAction(() => {
                videoStore.setCurrentTime(video.currentTime);
            });
        };

        video.addEventListener("loadedmetadata", handleLoadedMetadata);
        video.addEventListener("timeupdate", handleTimeUpdate);

        return () => {
            video.removeEventListener("loadedmetadata", handleLoadedMetadata);
            video.removeEventListener("timeupdate", handleTimeUpdate);
        };
    }, [framesLoaded, videoStore]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        if (videoStore.isPlaying) {
            video.play();
        } else {
            video.pause();
        }
    }, [videoStore.isPlaying]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        if (Math.abs(video.currentTime - videoStore.currentTime) > 0.1) {
            video.currentTime = videoStore.currentTime;
        }
    }, [videoStore.currentTime]);

    const handleVideoClick = () => {
        runInAction(() => {
            videoStore.setPlaying(!videoStore.isPlaying);
        });
    };
    console.log("videoStore.selectedVideo.url", videoStore.selectedVideo?.url);
    const handleContextMenu = (e: React.MouseEvent) => {
        e.preventDefault();
        videoStore.showContextMenu(e.clientX, e.clientY);
    };

    if (!videoStore.selectedVideo) return null;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxWidth: "90vw",
                maxHeight: "85vh",
                gap: "1.5rem",
            }}
        >
            <div
                style={{
                    position: "relative",
                    background: "#000",
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)",
                }}
            >
                <video
                    ref={videoRef}
                    src={videoStore.selectedVideo.url}
                    style={{
                        maxWidth: "80vw",
                        maxHeight: "60vh",
                        display: "block",
                        cursor: "pointer",
                    }}
                    onClick={handleVideoClick}
                    onContextMenu={handleContextMenu}
                    aria-label={`Video player: ${videoStore.selectedVideo.text}`}
                />
            </div>
            <StoryboardStrip />
        </div>
    );
});
